var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-button",
      class: { open: _vm.open },
      on: { click: _vm.toggle }
    },
    [
      _c("span", { staticClass: "top" }),
      _vm._v(" "),
      _c("span", { staticClass: "middle" }),
      _vm._v(" "),
      _c("span", { staticClass: "bottom" }),
      _vm._v(" "),
      _c("div", { staticClass: "close-menu" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }